export default __webpack_public_path__ + "static/media/logo-light.645edec5.png";